import type { AwardedFacility } from './types'

/**
 * GYYM AWARDS 受賞施設マスタ (SSoT)
 *
 * - キーは年度。「GYYM AWARDS 2025」(2026年発表・2025年のデータ) → 2025
 * - 次年度の受賞施設はここに年度キーを追加する
 * - 掲載順は LP の掲載順 (BEST GYM / BEST STUDIO は地域ごと) に合わせている
 * - LP でのみ必要な表示データ (地域・写真・リンク先・紹介文) は
 *   `app/awards/{年度}/_data` 側で facilityId をキーに保持する
 */
export const AWARDED_FACILITIES_BY_YEAR: Record<number, AwardedFacility[]> = {
  2025: [
    // 関東
    {
      facilityId: 506,
      name: 'スポーツクラブ&サウナ スパ ルネサンス新宿',
      category: 'BEST GYM',
    },
    { facilityId: 266, name: 'ティップネス横浜店', category: 'BEST GYM' },
    { facilityId: 121, name: 'メガロス三鷹', category: 'BEST GYM' },
    {
      facilityId: 367,
      name: 'フィットネスクラブ東京ドーム',
      category: 'BEST GYM',
    },
    {
      facilityId: 262,
      name: 'ティップネス駒沢大学24hours',
      category: 'BEST GYM',
    },
    { facilityId: 145, name: 'EXPA 銀座店', category: 'BEST STUDIO' },
    {
      facilityId: 136,
      name: 'マグマファスティングスタジオINSEA（インシー）五反田店',
      category: 'BEST STUDIO',
    },
    {
      facilityId: 404,
      name: 'MellowFlow(メローフロー) 新宿髙島屋',
      category: 'BEST STUDIO',
    },
    {
      facilityId: 733,
      name: 'STUDIO BREATH (スタジオ ブレス)',
      category: 'BEST STUDIO',
    },
    { facilityId: 147, name: 'EXPA 池袋店', category: 'BEST STUDIO' },
    // 関西
    {
      facilityId: 494,
      name: 'スポーツクラブ&サウナ スパ ルネサンス梅田',
      category: 'BEST GYM',
    },
    {
      facilityId: 694,
      name: 'エニタイムフィットネス 西大橋店',
      category: 'BEST GYM',
    },
    {
      facilityId: 794,
      name: 'スポーツクラブ&サウナ スパ ルネサンスもりのみやキューズモール24',
      category: 'BEST GYM',
    },
    { facilityId: 988, name: 'スポーツクラブNASあべの', category: 'BEST GYM' },
    { facilityId: 1051, name: 'HOS 布施スポーツクラブ', category: 'BEST GYM' },
    { facilityId: 362, name: 'STUDIO TRIVE', category: 'BEST STUDIO' },
    { facilityId: 1426, name: 'Kirari(キラリ)西宮', category: 'BEST STUDIO' },
    {
      facilityId: 340,
      name: 'ホットヨガスタジオ ビープラス 福島（西梅田）店',
      category: 'BEST STUDIO',
    },
    { facilityId: 410, name: 'STUDIO YO・GAN 京橋店', category: 'BEST STUDIO' },
    {
      facilityId: 341,
      name: 'ホットヨガスタジオ ビープラス 天満橋店',
      category: 'BEST STUDIO',
    },
    // 北海道
    {
      facilityId: 950,
      name: 'スポーツクラブNAS Vit Park 札幌',
      category: 'BEST GYM',
    },
    {
      facilityId: 760,
      name: 'エニタイムフィットネス 東札幌店',
      category: 'BEST GYM',
    },
    { facilityId: 949, name: 'スポーツクラブNAS札幌', category: 'BEST GYM' },
    // 東北
    {
      facilityId: 858,
      name: 'エニタイムフィットネス 広瀬通り店',
      category: 'BEST GYM',
    },
    {
      facilityId: 775,
      name: 'エニタイムフィットネス 八戸中央店',
      category: 'BEST GYM',
    },
    {
      facilityId: 596,
      name: 'ATTivoGYM（アッティーボジム）仙台アエル31店',
      category: 'BEST GYM',
    },
    // 北陸中部
    { facilityId: 562, name: 'メガロス千種', category: 'BEST GYM' },
    { facilityId: 561, name: 'メガロステラッセ納屋橋', category: 'BEST GYM' },
    {
      facilityId: 676,
      name: 'エニタイムフィットネス 名古屋栄店',
      category: 'BEST GYM',
    },
    // 中国四国
    {
      facilityId: 693,
      name: 'エニタイムフィットネス 松山大街道店',
      category: 'BEST GYM',
    },
    {
      facilityId: 690,
      name: 'エニタイムフィットネス 徳山病院店',
      category: 'BEST GYM',
    },
    {
      facilityId: 946,
      name: 'エニタイムフィットネス 広島曙店',
      category: 'BEST GYM',
    },
    // 九州・沖縄
    {
      facilityId: 424,
      name: 'SDフィットネス365 小倉駅前店',
      category: 'BEST GYM',
    },
    {
      facilityId: 1024,
      name: 'エニタイムフィットネス 鹿児島中央店',
      category: 'BEST GYM',
    },
    { facilityId: 997, name: 'スポーツクラブNAS六本松', category: 'BEST GYM' },
    { facilityId: 591, name: 'DAH Fitness 有明', category: 'BEST COMMUNITY' },
    { facilityId: 168, name: 'StrategicGym89', category: 'BEST COMMUNITY' },
    {
      facilityId: 1019,
      name: 'UBX GAKUGEIDAIGAKU',
      category: 'BEST COMMUNITY',
    },
    {
      facilityId: 149,
      name: 'ヨガスタジオグロウ 自由が丘スタジオ',
      category: 'BEST COMMUNITY',
    },
    { facilityId: 838, name: 'FITBASE24 四条大宮', category: 'BEST COMMUNITY' },
    { facilityId: 83, name: 'ZEROGYM 千駄ヶ谷', category: 'RISING STAR' },
    { facilityId: 906, name: 'WELLNESS HUB TOKYO', category: 'RISING STAR' },
    // 正式名称に合わせて「ストレッチジム パートナーズ」表記 (Figmaカンプは「ストレッチパートナーズ」)
    {
      facilityId: 241,
      name: 'ストレッチジム パートナーズ',
      category: 'RISING STAR',
    },
    {
      facilityId: 403,
      name: 'Mixa Wellness Studio -OMOTESANDO-(ミクサ-表参道-)',
      category: 'RISING STAR',
    },
    { facilityId: 191, name: 'エバーリゾート', category: 'RISING STAR' },
  ],
}
